import type { Direction } from '@wix/editor-elements-common-utils';
import { convertPhysicalAlignmentToLogical } from '@wix/editor-elements-common-utils';
import type { IShareButtonsCustomControls } from '../types';

export const migrateIconPosition = (
  legacyIconPosition:
    | IShareButtonsCustomControls['IconPosition']
    | undefined = 'left',
  legacyDirection: Direction | undefined = 'ltr',
) => {
  if (legacyIconPosition === 'top' || legacyIconPosition === 'bottom') {
    return legacyIconPosition;
  }

  return convertPhysicalAlignmentToLogical(legacyIconPosition, legacyDirection);
};
